import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { ProductoAcuerdo } from '../producto-acuerdo.model';
import { Producto } from '../../productos/producto.model';
import { Observable } from 'rxjs/Observable';
import { BackendService } from '../../core/backend.service';
import 'rxjs/add/observable/from';
import { Parametric } from '../../cliente/parametric.model';
import { TipoImpresion } from '../../productos/tipo-impresion/tipo-impresion.model';
import { Logo } from '../../cliente/logo.model';
import { ClienteService } from '../../core/cliente.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Talle } from '../../productos/talle/talle.model';
import { TipoMoneda } from '../../cliente/tipoMoneda.model';
import { Tarifario } from '../tarifario.model';
import { TarifarioPorCantidad } from '../tarifario-por-cantidad.model';
import { TarifarioAdicional } from '../tarifario-adicional.model';
import { CategoriaAcuerdo } from '../categoria-acuerdo.model';



@Component({
  selector: 'app-acuerdo-producto',
  templateUrl: './acuerdo-producto.component.html',
  styleUrls: ['./acuerdo-producto.component.scss']
})
export class AcuerdoProductoComponent implements OnInit {

  @Input() producto: ProductoAcuerdo;
  @Input() productosPosibles: Observable<Producto[]>;
  @Input() categorias: CategoriaAcuerdo[];

  private _logos: Logo[];
  get logos(): Logo[] {
    return this._logos;
  }

  @Input()
  set logos(logosInput: Logo[]) {
    this._logos = logosInput;
    this.getImagenesLogos();
  }

  productosObs: Producto[];
  tiposImpresion: Observable<TipoImpresion[]>;
  talles: Talle[];
  monedas: Observable<Parametric[]>;
  numberPattern = /^[0-9]*([.])?(\d{1,2})?$/;

  constructor(
    private sanitizer: DomSanitizer,
    private backendService: BackendService,
    private apiService: ApiService,
    private dialogService: DialogService,
    private clienteService: ClienteService) { }

  ngOnInit() {
    this.producto.producto = this.producto.producto ? this.producto.producto : this.backendService.new(Producto);
    this.producto.colores = this.producto.colores ? this.producto.colores : [];
    this.producto.producto.tiposImpresion = this.producto.producto.tiposImpresion ? this.producto.producto.tiposImpresion : [];
    this.producto.logos = this.producto.logos ? this.producto.logos : [];
    this.talles = this.producto.producto.talles ? this.producto.producto.talles : [];
    this.producto.tarifario = this.producto.tarifario ? this.producto.tarifario : new Tarifario();

    this.refreshTarfiarioAdicional(null);
    this.getTiposImpresion();
    this.getImagenesLogos();
    this.getTiposMonedas();

    if (!this.producto.id || this.producto.id === 0) {
      this.producto.logos = this.logos;
    }

    this.getProductosPosibles();
  }

  refreshTarfiarioAdicional(event) {
    this.producto.producto.tiposImpresion.filter(t => !this.producto.tarifario.adicionales
                                            .some(ta => ta.tipoImpresion.id === t.id ))
                                            .forEach(x => this.producto.tarifario.adicionales
                                              .push(new TarifarioAdicional(x)));
    this.producto.tarifario.adicionales.filter(t => !this.producto.producto.tiposImpresion
                            .some(ti => ti.id === t.tipoImpresion.id))
                            .forEach(x => this.producto.tarifario.adicionales.splice(this.producto.tarifario.adicionales.indexOf(x), 1));

  }

  async getProductosPosibles() {
    this.productosPosibles.toPromise().then(p => {
      this.productosObs = p;
    });
  }

  setOpcionesProducto(id) {
    this.refreshTarfiarioAdicional(null);
  }

  async getTiposImpresion() {
    this.tiposImpresion = this.backendService.get(TipoImpresion, TipoImpresion.path, {});
  }

  async getTiposMonedas() {
    this.monedas = this.apiService.get(Parametric, Parametric.path + 'tipos_monedas/', null);
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  imagesLoaded() {
    return this.logos.every(l => l.url);
  }

  async getImagenesLogos() {
    const imgs = [];
    this.logos.forEach(i => {
      const img = new Logo(null);
      img.id = i.id;
      img.name = i.name;
      img.path = i.path;
      if (i.path && i.path.indexOf('http') < 0) {
        this.getImages(img);
      } else {
        img.url = i.path + i.name;
      }

      imgs.push(img);
    });
    this.logos.splice(0);
    imgs.forEach(i => this.logos.push(i));
  }

  async getImages(imagen: Logo) {
    this.clienteService.getLogoById(imagen.id).subscribe(data => {
      const urlCreator = window.URL;
      const safeUrl: any = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
      imagen.url = safeUrl;
    });
  }

  private openWindow(img: Logo) {
    this.dialogService.imageViewer(img.name, '', img.url);
  }

  agregarPrecio() {
    this.producto.tarifario.preciosXCantidad.push(new TarifarioPorCantidad());
  }

  eliminarPrecio() {
    this.producto.tarifario.preciosXCantidad.splice(0, 1);
  }

  keyPress(event: any) {
    const pattern = /\d+$/;
    const patternPunto = /\./;
    const inputChar = String.fromCharCode(event.charCode);

    if (pattern.test(inputChar) || patternPunto.test(inputChar)) {
    } else { // invalid character, prevent input
        event.preventDefault();
    }
    let cantidad: string;
    const valor = event.path[0].value;
    if (valor !== null) {
      cantidad = valor.toString() + inputChar;
    }
    if (!this.numberPattern.test(cantidad)) {
      event.preventDefault();
    }
  }

  numeroCorrecto(numero: string) {
    const regex = /^\$?\d+(\.\d{1,2})?$/;
    return regex.test(numero);
  }

  onlyNum(event: any) {
    const pegado = event.clipboardData.getData('Text');
      if (this.numeroCorrecto(pegado)) {
        return pegado;
      } else {
        event.preventDefault();
      }
  }

  deleteCantMax(){
    if (!this.producto.limiteMax) {
      this.producto.cantidadMax = null;
    }
  }

  deleteCantMin(){
    if (!this.producto.limiteMin) {
      this.producto.cantidadMin = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-producto/acuerdo-producto.component.ts